<template>
  <div v-if="loading" class="fullscreen-centered">
    Loading...
  </div>
  <div v-else :class="{ 'mb4': !isEmbed }">
    <Preview v-for="(note, index) in notes" :key="index" :note="note" :single-view="true" />
  </div>
</template>

<script>
  import store from '@/store'
  import { mapState } from 'vuex'
  import Preview from '@/components/Preview'

  export default {
    name: 'Single',
    metaInfo: {
      title: 'Field Notes'
    },
    data () {
      return {
        loading: false,
        addMenuVisible: false,
        addNew: false
      }
    },
    computed: {
      ...mapState([ 'notes', 'drafts' ])
    },
    mounted () {
      this.loading = true;
      store.dispatch('getSingleNote', this.$route.params.id)
        .finally(() => {
          this.loading = false;
        });
    },
    methods: {
      async nextPage (loaded) {
        try {
          await store.dispatch('getNextPageOfLatestNotes')
          loaded('done')
        } catch (err) {
          loaded('fail')
          throw err
        }
      }
    },
    components: { Preview }
  }
</script>
